import request from 'src/utils/request';
import { tryJson } from 'utiljs-box';

export const getUserInfo = (params) => {
  return request.get('/api/common/getUserInfo', { params });
};

//获取名单认证方式
export const getAuthTypeBase = () => request.get('/api/car/admin/template/option');

// 保险权益列表-账号所属机构下所有权益
export const getPrizeTypes = () => request.get('/api/car/admin/common/prizeTypes');

// 获取数字验证码
export const getNumberCaptcha = () => request.get('/api/car/admin/captcha/picture');

/**
 * 通过配置名称获取配置值
 * @param {*} name 字段名
 * @param {*} isJson 是否转json
 */
export const getValueByName = async (name, isJson = false) => {
  const res = await request.get(`/api/car/front/pages/config/getValueByName/${name}`);
  if (isJson) {
    return tryJson(res);
  }
  return res;
};

// 获取七牛云上传token
export const getQiniuUploadToken = (params) =>
  request.post('/api/car/admin/common/qiniu/uploadToken', null, { params });

//查询全量权益产品
export const getAllPrizeType = () => request.get('/api/car/admin/common/prizeTypeBase');

// 查询所有银行
export const getAllBanks = () => request.get('/api/car/admin/common/banks');

// 查询所有商户
export const getAllMerchants = (params) =>
  request.get('/api/car/admin/common/merchants', { params });

// 查询所有商户
export const getSupplierOption = () => request.get('/api/car/admin/common/suppliers');
